export const isRussianLang = (str: string) => {
  const regex = /[а-яА-ЯЁё]/;
  // const regex = /^[а-яА-Яa-zA-Z0-9-]+$/;
  return regex.test(str);
};

export const isCurrentStr = (str: string) => {
  const regex = /^[a-zA-Z0-9\-]*$/; // можно англ + цифры + тире
  return regex.test(str);
};
